// Home's views other than a Report, kept in the URL as `view`. Without `view`
// or an open Report, Home lands on Exposure (Dhanur, 26 Oct 2026); an
// explicit `view` still wins.
export enum HomeView {
  ACTIVITY = "activity",
  EXPOSURE = "exposure",
}

// The view Home shows: null while a Report is open.
export const shownHomeView = ({
  view,
  report,
}: {
  view: HomeView | null
  report: string | null
}) => {
  if (report) return null
  return view ?? HomeView.EXPOSURE
}
